<template>
  <div class="hero">
    <section class="main">
      <div class="container">
        <div class="columns is-multiline">
          <div class="headline column is-12 is-one-third-widescreen">
            <h1>Votre agenda médical simplifié !</h1>
            <p>Avec goMedical, gérez facilement les rendez-vous médicaux de votre centre de santé</p>
            <p>
              <join-button/>
            </p>
          </div>
          <div class="column">
            <div class="hero-mockup">
              <img src="@/assets/img/mockup2.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import JoinButton from './JoinButton'

export default {
  components: {
    JoinButton
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomeHero.vue